import { api } from './client'

// FR-26: AI feedback analytics
export const getAIFeedbackAnalytics = (pid) =>
  api.get(`/ai/programs/${pid}/feedback-analytics`).then(r => r.data)
